import { render, staticRenderFns } from "./ProductDetailCard.vue?vue&type=template&id=25b32eb0&scoped=true&"
import script from "./ProductDetailCard.vue?vue&type=script&lang=js&"
export * from "./ProductDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailCard.vue?vue&type=style&index=0&id=25b32eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b32eb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
